import { createSlice } from '@reduxjs/toolkit';

import { storage } from '../Store.persist';

import { persistReducer } from 'redux-persist';

const initialState = {};

export const GeneralSelectors = {};

const generalSlice = createSlice({
	initialState,
	name: 'General',
	reducers: {},
});

export const GeneralActions = generalSlice.actions;
export const GENERAL_PERSIST_KEY = 'generalPersist';
export const GeneralReducer = persistReducer(
	{
		storage,
		key: GENERAL_PERSIST_KEY,
		whitelist: [''],
	},
	generalSlice.reducer
);
